/**
 * Users
 */

// React
import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getProductAction,
  getProductVariantsActions,
  getCategoriesAction,
  deleteVariantAction,
} from './actions';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectProductsVariantListByProductId,
  makeSelectProductsVariantListCount,
  makeSelectProduct,
  makeSelectCategoriesList,
  makeSelectCategoryLoading,
} from './selectors';
import { makeSelectSkusInventoryList } from '../warehouses/selectors';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/variantList';
import Edit from './components/edit';
import Add from './components/add';
import Details from './components/detail';
import Inventory from './components/inventory';
import CSV from './components/csv';
import Modal from '../../components/Modal';
import ReportList from '../warehouseInventory/components/reportList';
import ProductsMobile from './mobileView/product';

// UI
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Paper,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
  FormControl,
  Select,
  MenuItem,
  Box,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import { mdiArrowRight, mdiKeyOutline, mdiArchiveOutline, mdiChatOutline } from '@mdi/js';

// Helper
import { removeEmptyValueObject, flattenObject } from '../../utils/helpers';
import handleError from '../../utils/handleError';

// Type
import { Props, SelectorPropsVariants } from './interfaces';
import { Filter } from '../../utils/listDaynamicFilterHookForm';
import Can from '../../components/Can';
import { GetInventoryFlowRequestBuilder } from 'client-sdk/src/skus/skus';
import Client from 'client-sdk/src/client';
import classes from './product.module.scss';
import windowSize from '../../utils/hook/useWindowResize';
import Bell from '../../components/Notification/Bell';
import TicketLink from '../../components/ticketLink';

// Const
interface ObjectString {
  edit: string;
  detail: string;
  assign: string;
  inventory: string;
}
const translate: ObjectString = {
  edit: 'ویرایش',
  detail: 'جزیيات محصول',
  assign: 'لیست محصول',
  inventory: 'گزارش موجودی محصول',
};

const Products: FunctionComponent<Props> = (
  props: Props
): React.ReactElement => {
  const authContext = useContext(AuthContext);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [filters, setFilters] = useState([] as Filter[]);
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);
  const urlParams = useParams();
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [type, setType] = useState('edit' as string);

  const [openAdd, setopenAdd] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);

  const [openSizeReport, setOpenSizeReport] = React.useState(false as boolean);

  const [reportModal, setReportModal] = useState(false as boolean);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [reportLoading, setReportLoading] = useState(false as boolean);
  const [reportList, setReportList] = useState<any>(null);
  const [reportFilters, setReportFilters] = useState<any>({
    page: 0,
    size: 10,
  });

  const [reportId, setReportId] = useState(null as any);
  const [reportCsvData, setReportCsvData] = useState([]);
  const [reportCsvLoading, setReportCsvLoading] = useState(false);
  const [inventoryFilters, setInventoryFilters] = useState({
    page: 0,
    size: 10,
  } as any);
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();

  const token = localStorage.getItem('token') || '';

  const handleCloseReportModal = () => {
    setReportModal(false);
    setFiltersValues({
      page: 0,
      size: 10,
    });
    setReportList(null);
    setReportCsvData([]);
  };
  const handleChangeSizeReportList = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setReportFilters({ ...reportFilters, page: 0, size: event.target.value });
    fetchReportList(reportId, { ...reportFilters, size: event.target.value });
  };

  const fetchReportCsv = async () => {
    try {
      setReportCsvLoading(true);
      const parcelId = selectedItem.id;
      const request = new GetInventoryFlowRequestBuilder()
        .id(parcelId)
        .params({ size: 10000 })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(request);
      setReportCsvData(data.content);
    } catch (e) {
      handleError(e.response);
    } finally {
      setReportCsvLoading(false);
    }
  };
  const fetchReportList = async (id: number, args: Record<string, any>) => {
    try {
      setReportLoading(true);
      const request = new GetInventoryFlowRequestBuilder()
        .id(id)
        .params({
          ...removeEmptyValueObject(flattenObject(reportFilters)),
          ...args,
        })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(request);
      setReportList(data);
    } catch (err) {
      handleError(err.response);
    } finally {
      setReportLoading(false);
    }
  };
  const findSelectedItem = (id: number) => {
    const findSelectSku = props.skusInventoryList.find(
      (el: any) => el.id === id
    )!;
    setSelectedItem(findSelectSku);
  };

  const handleReport = (id: number) => {
    setReportModal(true);
    setReportId(id);
    fetchReportList(id);
    // props.getParcelsDispatch({'skuId.equals': id, size: 150});
    findSelectedItem(id);
  };

  const handleChangeReportPage = (
    _: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setReportFilters({ ...reportFilters, page: page - 1 });
    fetchReportList(reportId, { ...reportFilters, page: page - 1 });
  };

  const handleGetParcelInventory = (id: number) => {
    setInventoryFilters((prevState: Record<string, any>) => ({
      ...prevState,
      'parcelId.equals': id,
    }));
    getParcelInventoryRequest({ 'parcelId.equals': id });
  };
  const getParcelInventoryRequest = (arg: Record<string, any>) => {
    props.getParcelInventoryItems({ ...inventoryFilters, ...arg });
  };

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  useEffect(() => {
    getProduct();
    getProductVariants();
    setupFilters();
  }, [filtersValues]);

  useEffect(() => {
    setupFilters();
  }, [props.categoryLoading]);

  const getProduct = () => {
    const { page, size } = filtersValues;
    const { partnerId } = props.match.params;
    props.productDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: { equals: partnerId },
      id: urlParams.id,
      page,
      size,
    });
  };

  const getProductVariants = () => {
    const { page, size } = filtersValues;
    const { partnerId } = props.match.params;
    props.productVariantsDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: { equals: partnerId },
      id: urlParams.id,
      page,
      size,
    });
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const setupFilters = () => {
    Can({
      role: authContext.user.role,
      perform: 'orders:filtersByCenterId',
      yes: () => {
        setFilters([
          {
            type: 'input',
            id: 'code.equals',
            label: 'کد تنوع کالا',
            icon: mdiArchiveOutline,
          },
          {
            type: 'input',
            id: 'sellerName.equals',
            label: 'نام فروشنده / تامین کننده',
            icon: mdiKeyOutline,
          },
        ]);
      },
      no: () => {
        setFilters([
          {
            type: 'input',
            id: 'code.equals',
            label: 'کد تنوع کالا',
            icon: mdiArchiveOutline,
          },
          {
            type: 'input',
            id: 'sellerName.equals',
            label: 'نام فروشنده / تامین کننده',
            icon: mdiKeyOutline,
          },
        ]);
      },
    });
  };

  const handleDisableUser = async () => {
    const body = props.productsVariantsList.find(item => item.id === id) as any;
    await props.updateProductsDispatch({
      body: { ...body, status: 'SUSPENDED' },
      pagination: filtersValues,
      id: props.match.params.partnerId,
    });
    setOpenConfirmDisable(false);
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenConfirmDisable(true);
    setId(id);
  };
  const handleOpen = (id: number, type: string) => {
    setType(type);
    setOpenDialog(true);
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenDialog(false);
    setopenAdd(false);
  };

  const handleOpenConfirmUpdateState = (data: { id: number; body: any }) => {
    setId(data.id);
  };

  const handleDelete = async (id: number) => {
    await props.deleteVariantDispatch({
      id,
      callback: getProductVariants
    });
  }

  return isMob ? (
    <ProductsMobile {...props} />
  ) : (
    <div className={classes.root}>
      <Grid
        className={classes.topBox}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={0}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2" className={classes.title}>
              {`جزیيات `}
              {props.product.name.concat(' - ', props.product.id)}
            </Typography>
            <span style={{ marginRight: 'auto', marginLeft: '130px' }}>
              <TicketLink />
            </span>
          </div>
        </Paper>
      </Grid>
      <Grid container spacing={1} alignItems="flex-start">
        <Grid item xs={12} lg={3} md={3}>
          <Details product={props.product} />
        </Grid>
        <Grid item lg={9} md={9} xs={12}>
          <Card className={classes.card} style={{ padding: '14px 0  0' }}>
            <CardHeader
              avatar={
                <Typography
                  className={classes.typographyCards}
                  style={{ marginRight: '-25px' }}
                >
                  {`لیست تنوع کالا`}
                  {props.product.name.concat(' - ', props.product.id)}
                </Typography>
              }
            />

            <CardContent style={{ margin: '15px 0  0', padding: '0' }}>
              <Grid item xs={12}>
                {props.loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  props.productsVariantsList && (
                    <List
                      handleDelete={handleDelete}
                      handleReport={handleReport}
                      data={props.productsVariantsList}
                      productName={props.product.name}
                      handleOpenConfirmDisable={handleOpenConfirmDisable}
                      handleOpen={handleOpen}
                      changeStatus={handleOpenConfirmUpdateState}
                    />
                  )
                )}
              </Grid>
              <Grid
                md={12}
                container
                justifyContent="space-between"
                style={{ marginTop: '10px', padding: '10px' }}
              >
                <Grid id="showFilter" item xs={6} sm={6}>
                  {props.productsVariantsList && (
                    <FormControl
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                        {' '}
                        تعداد نمایش در هر صفحه:
                      </div>
                      <Select
                        open={openSize}
                        onClose={handleCloseSelect}
                        className={classes.showCount}
                        onOpen={() => setOpenSize(true)}
                        value={filtersValues.size}
                        onChange={handleChangeSizePage}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </Grid>
                <Grid container item md={6} direction="row-reverse">
                  {props.productsVariantsList && (
                    <Pagination
                      count={Math.ceil(
                        props.productVariantListCount / filtersValues.size
                      )}
                      color="secondary"
                      page={filtersValues.page + 1}
                      onChange={handleChangePage}
                    />
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={openConfirmDisable}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          {` آیا از غیر فعال کردن محصول با نام
          "${props.productsVariantsList.find(item => item.id === id)?.name}"
          اطمینان دارید؟`}
        </DialogTitle>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleClose}
            variant="contained"
            color="primary"
          >
            {`خیر`}
          </Button>
          <Button
            onClick={handleDisableUser}
            variant="outlined"
            color="primary"
          >
            {`بله`}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>{` 
          ${translate[type]}
        "${props.productsVariantsList.find(item => item.id === id)?.name}"
        `}</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          {type === 'edit' && (
            <Edit
              data={props.productsVariantsList.find(item => item.id === id)}
              partnerId={props.match.params.partnerId}
              update={body => {
                props.updateProductsDispatch({
                  body,
                  pagination: filtersValues,
                  id: props.match.params.partnerId,
                });
                handleClose();
              }}
            />
          )}

          {type === 'inventory' && (
            <Inventory
              data={props.productsVariantsList.find(
                product => product.id === id
              )}
            />
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        fullScreen
        open={openAdd}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>ایجاد محصول جدید</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          <Add
            partnerId={props.match.params.partnerId}
            create={body => {
              props.createProductDispatch({
                body,
                pagination: filtersValues,
                id: props.match.params.partnerId,
              });
              handleClose();
            }}
          />
        </DialogContent>
      </Dialog>
      <Modal
        maxWidth="md"
        onClose={handleCloseReportModal}
        open={reportModal}
        title={
          <div style={{ textAlign: 'right' }}>
            <span>{`تاریخچه ورود و خروج کالای ${props.product.name}`}</span>
          </div>
        }
        content={
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {reportLoading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <React.Fragment>
                  <Grid item xs={12}>
                    <div style={{ textAlign: 'left' }}>
                      <Can
                        role={authContext.user.role}
                        perform="skus:downloadCSV"
                        yes={() => (
                          <CSV
                            loading={reportCsvLoading}
                            handleCreateCSV={fetchReportCsv}
                            data={reportCsvData}
                          />
                        )}
                      />
                    </div>
                    <Box mb={3} />
                  </Grid>
                  <ReportList
                    data={reportList?.content}
                    handleSelect={handleGetParcelInventory}
                  />
                </React.Fragment>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSizeReport}
                  onClose={() => setOpenSizeReport(false)}
                  onOpen={() => setOpenSizeReport(true)}
                  value={reportFilters.size}
                  onChange={handleChangeSizeReportList}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              <Pagination
                className={classes.pagination}
                count={Math.ceil(
                  reportList?.totalElements / reportFilters.size
                )}
                color="secondary"
                page={reportFilters?.page + 1}
                onChange={handleChangeReportPage}
              />
            </Grid>
          </Grid>
        }
      />
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorPropsVariants>({
  skusInventoryList: makeSelectSkusInventoryList(),
  product: makeSelectProduct(),
  categoriesList: makeSelectCategoriesList(),
  productsVariantsList: makeSelectProductsVariantListByProductId(),
  productVariantListCount: makeSelectProductsVariantListCount(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  categoryLoading: makeSelectCategoryLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    deleteVariantDispatch: (payload: object) => dispatch(deleteVariantAction(payload)),
    productDispatch: (payload: Object) => dispatch(getProductAction(payload)),
    categoriesDispatch: (payload: Object) =>
      dispatch(getCategoriesAction(payload)),
    productVariantsDispatch: (payload: Object) =>
      dispatch(getProductVariantsActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Products);
